import { actionGenerator } from '../../utils/redux/actionGenerator';
import { filtersActionTypes } from '../../constants/actionTypes';
import { EDealType, EGeoName, ECategory } from '../../types/share';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TThunkDispatch, IApplicationState, IContext } from '../../types/redux';
import { IChartState } from '../../types/charts';

import { prepareDataCharts } from './utils';
import { getAllCharts } from '../../api/charts';
import { updateQueryString } from '../queryString';
import { setLoading } from '../charts';
import { setGlobalError } from '../globalError';
import { DEFAULT_ERROR_MESSAGE } from '../../constants/errors';
import { IFilters } from '../../types/filters';

export const setDealType = actionGenerator<filtersActionTypes.SET_DEAL_TYPE, EDealType>(
  filtersActionTypes.SET_DEAL_TYPE,
);
export const setRegion = actionGenerator<filtersActionTypes.SET_REGION, EGeoName>(filtersActionTypes.SET_REGION);
export const setCategory = actionGenerator<filtersActionTypes.SET_CATEGORY, ECategory>(filtersActionTypes.SET_CATEGORY);
export const setChartsData = actionGenerator<filtersActionTypes.SET_CHARTS_DATA, Omit<IChartState, 'loading'>>(
  filtersActionTypes.SET_CHARTS_DATA,
);

export type TSetDealAction = ITypedReduxAction<filtersActionTypes.SET_DEAL_TYPE, EDealType>;
export type TSetRegion = ITypedReduxAction<filtersActionTypes.SET_REGION, EGeoName>;
export type TSetCategory = ITypedReduxAction<filtersActionTypes.SET_CATEGORY, ECategory>;
export type TSetChartsData = ITypedReduxAction<filtersActionTypes.SET_CHARTS_DATA, Omit<IChartState, 'loading'>>;

export type TFiltersActions = TSetDealAction | TSetRegion | TSetCategory | TSetChartsData;

type TMapDispatch = { [key in keyof IFilters]: Function };
type TValue = EDealType | EGeoName | ECategory;

const mapDispatch: TMapDispatch = {
  dealType: setDealType,
  region: setRegion,
  category: setCategory,
};

export function updateCharts(filerName: keyof IFilters, value: TValue) {
  return (dispatch: TThunkDispatch, getState: () => IApplicationState, context: IContext) => {
    const { httpApi, config, logger } = context;

    dispatch(setLoading(true));
    dispatch(setGlobalError(null));
    dispatch(mapDispatch[filerName](value));

    const {
      charts: prevChartsData,
      filters: { category, region },
      webview,
    } = getState();

    const params = {
      category,
      geoName: region,
    };

    return getAllCharts({ httpApi, config, params })
      .then(([chartPrice, chartDemand, chartSupply, chartMortgage]) => {
        const newChartData = prepareDataCharts({ chartPrice, chartDemand, chartSupply, chartMortgage, prevChartsData });

        dispatch(setChartsData(newChartData));

        if (!webview) {
          dispatch(updateQueryString());
        }
        dispatch(setLoading(false));
      })
      .catch(e => {
        logger.error('Failed get /v1/charts in browser', e);

        dispatch(setLoading(false));
        dispatch(setGlobalError(DEFAULT_ERROR_MESSAGE));
      });
  };
}
